var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1684 1190",
    width: 1684,
    height: 1190,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Business man 01-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 860.9,
    y1: 375.3,
    x2: 931.6,
    y2: 323.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 942,
    y1: 243.1,
    x2: 1012.7,
    y2: 191.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 1104.7,
    y1: 456.2,
    x2: 1175.5,
    y2: 404.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 1270.6,
    y1: 278.6,
    x2: 1341.3,
    y2: 226.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#000000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #e1edff } \n\t\t.s2 { fill: #b1d4fc } \n\t\t.s3 { fill: #2a4589 } \n\t\t.s4 { fill: none;stroke: #231f20;stroke-width: 1.1 } \n\t\t.s5 { fill: #f65a7f } \n\t\t.s6 { fill: #7fccdb } \n\t\t.s7 { mix-blend-mode: multiply;fill: url(#g1) } \n\t\t.s8 { fill: #fafafa } \n\t\t.s9 { mix-blend-mode: multiply;fill: url(#g2) } \n\t\t.s10 { mix-blend-mode: multiply;fill: url(#g3) } \n\t\t.s11 { mix-blend-mode: multiply;fill: url(#g4) } \n\t\t.s12 { fill: #d3747d } \n\t\t.s13 { fill: #f3b1b1 } \n\t\t.s14 { fill: #1f3e7a } \n\t\t.s15 { fill: #fbb34a } \n\t\t.s16 { fill: #ef9f37 } \n\t\t.s17 { fill: #ffffff;stroke: #231f20;stroke-width: 2 } \n\t\t.s18 { fill: #001943 } \n\t\t.s19 { fill: #80bcf9 } \n\t\t.s20 { fill: #4c89d3 } \n\t\t.s21 { fill: #9cc1f4 } \n\t\t.s22 { fill: #7aaaec } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1683.8 1190h-1683.8v-1190.6h1683.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m1124.1 1062.2h-832.3c-42-22.2-78.2-55.4-102.5-96.2-31.6-52.8-43.5-115.2-46.2-176.6-2.2-49.3 1.2-99.4 16.4-146.3 22.7-70.4 70.3-130 120.5-184.4 55.8-60.5 116.7-117.4 187.2-160.1 70.5-42.6 151.4-70.6 233.8-70 74.6 0.5 147.2 24.2 215.7 53.9 107.7 46.7 211.5 112.1 277.1 209.5 74.3 110.4 91 256.1 48.9 382.4-23.7 71-65.2 135.3-118.6 187.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "<Path>",
    className: "s2",
    x: 773.5,
    y: 81.6,
    width: 697.3,
    height: 487.1,
    rx: 22.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1452.3 547.2h-660.3v-444.1h660.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m900.5 315.1v-64.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m916.7 351.3v-80.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m933 369.1v-45.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m949.3 357.7v-32.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m965.6 351v-46.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m981.8 324v-38.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m998.1 271.7v-39.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1014.4 283.5v-83.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1030.7 232v-64.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1046.9 260v-47.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1063.2 271.7v-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1079.5 262.8v-30.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1095.8 308.6v-87.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1112 368.1v-91.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1128.3 384.7v-79.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1144.6 337.5v-43.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1160.9 349.9v-45.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1177.1 363.5v-30.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1193.4 435.1v-93.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1209.7 441.4v-173"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1226 400.6v-174.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1242.2 404.7v-125.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1258.5 368.1v-94.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1274.8 319.1v-51.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1291.1 344.8v-75.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1307.4 359.7v-85.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1323.6 356.2v-41.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1339.9 347v-38.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1356.2 284.7v-52.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1372.5 318.5v-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1388.7 352.2v-59.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1405 420.7v-119.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m906.3 303h-11.7v-46.8h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m922.6 341.2h-11.8v-38.2h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m938.9 341.2h-11.8v-3.3h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m955.2 348h-11.8v-6.8h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m971.4 348h-11.7v-32.9h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m987.7 315.1h-11.8v-12.9h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1004 263.7h-11.8v-15.8h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1020.3 247.9h-11.8v-31.8h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1036.5 222.6h-11.7v-6.5h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1052.8 248.9h-11.7v-32.8h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1069.1 256.4h-11.8v-7.5h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1085.4 256.4h-11.8v-18.2h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1101.7 298.6h-11.8v-60.4h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1117.9 338.5h-11.7v-39.9h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1134.2 338.5h-11.8v-26.6h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1150.5 326.6h-11.8v-14.7h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1166.8 342.2h-11.8v-15.6h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1183 351.1h-11.7v-8.9h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1199.3 429.1h-11.8v-78h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1215.6 429.1h-11.8v-126.5h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1231.9 393.6h-11.8v-91h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1248.1 393.6h-11.7v-73.5h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1264.4 320.1h-11.8v-8.2h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1280.7 311.9h-11.8v-32.1h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1297 284.7h-11.8v-4.9h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1313.2 320.1h-11.7v-35.4h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1329.5 338.5h-11.8v-18.4h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1345.8 338.5h-11.8v-20.2h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1362.1 272.5h-11.8v-20.3h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1378.3 311.9h-11.7v-59.7h11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1394.6 319.1h-11.8v-7.2h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1410.9 400.4h-11.8v-81.3h11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m930.2 368.1l-52.5 40.1-16.1-28.5 62.7-35.4 25 4.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m929.9 365.3h-72.1v-32.7h72.1l19.4 16.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m879 342c0.9-0.1 2.1-0.3 3.4-0.3 1.9 0 3.1 0.4 4 1.1 0.8 0.5 1.2 1.4 1.2 2.5 0 1.4-0.9 2.6-2.4 3.2 1.3 0.4 2.9 1.5 2.9 3.7 0 1.2-0.5 2.1-1.2 2.8-1 1-2.6 1.4-5 1.4-1.2 0-2.2-0.1-2.9-0.2zm1.9 5.9h1.7c2 0 3.1-1 3.1-2.4 0-1.7-1.3-2.3-3.1-2.3-0.9 0-1.4 0-1.7 0.1zm0 6.9q0.6 0.1 1.6 0.1c1.9 0 3.7-0.7 3.7-2.8 0-2-1.7-2.8-3.8-2.8h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m892.5 341.8v8.6c0 3.2 1.4 4.6 3.4 4.6 2.1 0 3.5-1.4 3.5-4.6v-8.6h1.9v8.5c0 4.4-2.4 6.2-5.5 6.2-3 0-5.2-1.7-5.2-6.2v-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m907.7 356.3v-6.2l-4.6-8.3h2.1l2.1 4c0.5 1.1 1 2 1.4 3h0.1c0.4-0.9 0.9-1.9 1.4-3l2.1-4h2.1l-4.8 8.3v6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m917.4 352.2v-0.6c-0.1-1.1 0.3-2.4 1.3-3.7 1-1.1 1.5-1.9 1.5-2.9 0-1.1-0.7-1.8-2-1.8-0.8 0-1.6 0.2-2.2 0.6l-0.5-1.3c0.7-0.5 1.9-0.9 3.1-0.9 2.4 0 3.5 1.5 3.5 3.2 0 1.4-0.8 2.5-1.8 3.7-0.9 1.1-1.3 2-1.2 3.1v0.6zm-0.5 3c0-0.8 0.6-1.4 1.3-1.4 0.8 0 1.3 0.6 1.3 1.4 0 0.7-0.5 1.3-1.3 1.3-0.7 0-1.3-0.6-1.3-1.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1011.2 235.9l-52.4 40.1-16.1-28.5 62.7-35.4 25 4.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1010.9 233.1h-72v-32.7h72l19.5 16.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m959.9 221.8c0.8 0.5 2 0.9 3.3 0.9 1.9 0 3-1 3-2.4 0-1.4-0.8-2.1-2.7-2.9-2.4-0.8-3.8-2.1-3.8-4.1 0-2.2 1.8-3.9 4.6-3.9 1.5 0 2.6 0.3 3.2 0.7l-0.5 1.5c-0.4-0.2-1.4-0.7-2.7-0.7-2 0-2.7 1.2-2.7 2.2 0 1.4 0.8 2 2.8 2.8 2.5 0.9 3.7 2.1 3.7 4.2 0 2.2-1.6 4.2-5 4.2-1.4 0-2.9-0.4-3.7-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m978.1 217.3h-5.6v5.2h6.3v1.6h-8.1v-14.5h7.7v1.6h-5.9v4.6h5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m981.2 209.6h1.8v12.9h6.2v1.6h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m991.3 209.6h1.8v12.9h6.2v1.6h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1002.8 220l-0.1-0.6c-0.1-1.1 0.3-2.4 1.3-3.7 1-1.1 1.5-2 1.5-2.9 0-1.1-0.6-1.8-2-1.9-0.8 0-1.6 0.3-2.1 0.7l-0.6-1.3c0.7-0.6 2-0.9 3.1-0.9 2.5 0 3.6 1.5 3.6 3.1 0 1.5-0.8 2.5-1.9 3.8-0.9 1.1-1.3 2-1.2 3.1v0.6zm-0.4 3c0-0.8 0.5-1.4 1.2-1.4 0.8 0 1.3 0.6 1.3 1.4 0 0.7-0.5 1.3-1.3 1.3-0.7 0-1.2-0.6-1.2-1.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m1174 449.1l-52.5 40.1-16.1-28.5 62.8-35.5 24.9 4.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m1173.7 446.3h-72v-32.7h72l19.4 16.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s8",
    d: "m1122.9 423c0.8-0.2 2.1-0.3 3.4-0.3 1.8 0 3 0.3 3.9 1 0.8 0.6 1.2 1.5 1.2 2.6 0 1.4-0.9 2.6-2.4 3.2 1.4 0.3 3 1.5 3 3.6 0 1.3-0.5 2.2-1.3 2.9-1 0.9-2.6 1.3-4.9 1.3-1.3 0-2.3 0-2.9-0.1zm1.8 5.9h1.7c2 0 3.2-1 3.2-2.4 0-1.7-1.3-2.4-3.2-2.4-0.9 0-1.4 0.1-1.7 0.1zm0 6.9q0.6 0.1 1.6 0.1c1.9 0 3.7-0.7 3.7-2.8 0-1.9-1.7-2.8-3.7-2.8h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1136.3 422.8v8.5c0 3.3 1.5 4.6 3.4 4.6 2.1 0 3.5-1.4 3.5-4.6v-8.5h1.9v8.4c0 4.4-2.4 6.3-5.5 6.3-2.9 0-5.2-1.7-5.2-6.2v-8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1151.5 437.2v-6.1l-4.5-8.3h2.1l2 4c0.6 1.1 1 1.9 1.4 3h0.1c0.4-1 0.9-1.9 1.4-3l2.1-4h2.1l-4.8 8.3v6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1161.3 433.1l-0.1-0.5c-0.1-1.2 0.3-2.4 1.4-3.7 0.9-1.2 1.5-2 1.5-3 0-1-0.7-1.8-2.1-1.8-0.8 0-1.6 0.3-2.1 0.7l-0.6-1.4c0.7-0.5 2-0.8 3.1-0.8 2.5 0 3.6 1.5 3.6 3.1 0 1.5-0.8 2.5-1.9 3.7-0.9 1.1-1.2 2.1-1.2 3.2v0.5zm-0.4 3c0-0.8 0.5-1.3 1.3-1.3 0.7 0 1.2 0.5 1.2 1.3 0 0.8-0.5 1.4-1.3 1.4-0.7 0-1.2-0.6-1.2-1.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1339.9 271.5l-52.5 40.1-16.1-28.5 62.7-35.5 25 4.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m1339.6 268.7h-72.1v-32.7h72.1l19.4 16.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1288.5 257.4c0.8 0.5 2 0.9 3.3 0.9 1.9 0 3-1 3-2.5 0-1.3-0.7-2.1-2.7-2.8-2.3-0.9-3.8-2.1-3.8-4.1 0-2.3 1.9-3.9 4.7-3.9 1.4 0 2.5 0.3 3.2 0.7l-0.6 1.5c-0.4-0.3-1.4-0.7-2.7-0.7-2 0-2.7 1.2-2.7 2.2 0 1.3 0.9 2 2.9 2.7 2.4 1 3.6 2.2 3.6 4.3 0 2.2-1.6 4.1-5 4.1-1.4 0-2.9-0.4-3.7-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1306.7 252.9h-5.6v5.2h6.3v1.5h-8.1v-14.4h7.8v1.6h-6v4.5h5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1309.8 245.2h1.9v12.9h6.1v1.5h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1319.9 245.2h1.9v12.9h6.1v1.5h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s8",
    d: "m1331.4 255.5l-0.1-0.5c-0.1-1.2 0.3-2.4 1.4-3.7 0.9-1.2 1.5-2 1.5-3 0-1-0.7-1.8-2.1-1.8-0.7 0-1.6 0.3-2.1 0.7l-0.5-1.4c0.7-0.5 1.9-0.8 3-0.8 2.5 0 3.6 1.5 3.6 3.1 0 1.5-0.8 2.5-1.9 3.7-0.9 1.1-1.2 2.1-1.2 3.2l0.1 0.5zm-0.5 3c0-0.8 0.5-1.3 1.3-1.3 0.7 0 1.2 0.5 1.2 1.3 0 0.8-0.5 1.4-1.3 1.4-0.7 0-1.2-0.6-1.2-1.4z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1318 1074.6h-1112.2v-12.4h1112.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m614.1 469.7c2.8-9.1 5.4-18.1 8.1-27.1 0.9 6.9 2.5 13.7 5 20.2 0.2 0.7 0.5 1.4 0.4 2.1-0.1 1-0.8 1.7-1.6 2.3-2.7 2-6.3 2.3-9.8 2.4q-1 0.1-2.1 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m604.6 488.9c-6.1 4-14.2 1.4-20.9-1.2-16.3-6.3-34.3-8.5-48.2-19.9-3.2-2.6-6.9-4.5-9.8-7.5-0.4-0.3-0.7-0.7-0.7-1.2 0-0.4 0.2-0.7 0.4-1.1 4.5-7 8.4-16 15-21.3 0.4-0.3 5.1-4.5 4.8-4.6-7.3-2.2-12.4-9.3-13.9-16.8-1.3-7.2 0.4-15.2 5.6-20.4 5.2-5.2 13.9-6.9 20.1-3 6.2 3.9 8.4 13.5 3.6 19 10.5-3.7 19.9-10.4 26.7-19.2 11.7 11.7 27.1 19.5 43.4 22.4q-4.2 14.3-8.5 28.5c-2.7 9-5.3 18-8.1 27.1q-0.8 2.8-1.6 5.5c-1.6 5.2-3.4 10.8-7.9 13.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m572.2 483.1c-7.5 8.3-16 15.8-25.1 22.3q-1.4-1.9-2.7-3.9c-6.8-10.5-10.5-22.7-12.2-35.1q-0.7-5.2-1-10.3c10.5 12.8 25.5 20.6 41 27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m613.8 438.2c-0.7 1.8-2.8 2.6-4.6 1.8-1.7-0.8-2.5-2.8-1.7-4.6 0.7-1.8 2.8-2.6 4.6-1.8 1.7 0.8 2.5 2.9 1.7 4.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m552.3 422.4c-4.7 4.6-10.8 1.3-11.2-4.9-0.2-3 1.1-6.1 3.3-8.2 0.9-0.8 1.9-1.4 2.7-2.3 0.7-0.9 1.2-2.1 0.8-3.2-0.4-1.3-1.9-1.9-3.2-1.8-1.3 0.1-2.5 0.8-3.7 1.5q-1.5 0.8-3 1.7c1.8-3.3 4.5-6.4 8.1-7.4 2.9-0.7 6.8 0.4 8.2 3.2 1.1 2.3 0.1 4.4-0.6 6.7-1.4 5.1 3.2 10.1-1.4 14.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m634.1 414.7c-1.1-0.1-2.3-0.4-3.4-0.6-16.3-2.9-31.7-10.7-43.4-22.4-6.8 8.8-16.2 15.5-26.7 19.2 4.8-5.5 2.6-15.1-3.6-19-6.2-3.9-14.9-2.2-20.1 3-5.2 5.2-6.9 13.2-5.6 20.4 1.4 6.9 7.9 17.8 16 17.8 0.3 4.9-2.2 9.7-5.9 12.9-3.8 3.2-8.6 4.9-13.5 5.6-6.4 0.9-12.8 0.1-19.2 0.6 5.9-9.5 12.1-19 15.2-29.7 2.8-9.2 3.1-18.9 3.9-28.5 1.1-12.2 3.1-24.5 8.1-35.6 5-11.1 13.5-21.1 24.7-26 4.4-1.9 9.3-3.1 14-2.2 6.2 1.2 11.3 5.6 15.3 10.5 9.8-8 20.7-10.2 32.8-7.7 14.5 2.9 29.1 8.9 38.3 20.5 7.7 9.6 11 22.6 8.8 34.7-3.7 20.4-15.2 29.3-35.7 26.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m561.1 501.2c-2.4 5.6-3.3 11.8-2.6 17.9q0.1 0.4 0.1 0.8c-10.7-11-21.4-21.8-33.5-31.4-7.9-6.3-16.2-12.7-22.8-20.5q11.6-5.8 23.2-11.6c15.5 10.1 28.8 23.8 38.1 39.9q-1.4 2.3-2.5 4.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m621.1 598.4c-2.8 21.6-19.4 41.1-40.6 46.8-2.4 0.7-4.9 1.1-7.3 1.6q-0.4-0.7-0.7-1.5c-0.5-1.5-0.6-3.1-0.4-4.6-4.7-1.8-8.7-5.9-12.1-9.8-4.9-5.5-9.6-11-14.3-16.5q-0.3-0.3-0.6-0.7-7.8-9-15.5-18c-1 9.2-1.4 18.4-1.2 27.6 0.2 9.1 1 18.3 2.4 27.3 1.4 8.4 3.8 17.5 10.8 22.2 1 0.7 2.5 1.2 3.4 0.4q0.5 2.9 1 5.9c0.1 0.9 0.3 2 0 2.9q0 0.1-0.1 0.2c-0.4 1.1-1.4 1.9-2.4 2.6-16.6 12.1-35.8 23.1-55.9 28-10.2 2.5-20.8 3.6-30.1 8.4-10.7 5.5-18.4 15.2-25.9 24.6-6.4 8.2-13 16.6-16.8 26.3-11.5-25.4-6.6-49.6-6.1-76 0.6-30.5 3.9-61.1 5-91.6 0.3-9.9 0.7-19.7 2.1-29.4 5.1-33.9 29.5-73.3 58.5-92.2 5.6-3.7 11.7-6.7 17.7-9.7q5.1-2.6 10.3-5.2c6.6 7.8 14.9 14.2 22.8 20.5 12.1 9.6 22.8 20.4 33.5 31.4q0-0.4-0.1-0.8 1.8 3.9 3.8 7.8 2.8 5.3 6.1 10.4c7.8 12 17.5 22.5 27.1 33q12.8 14 25.6 28.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m528.4 623.3c-12.7-17.5-20.5-38.6-26.4-59.6q13.8 16 27.6 32c-1 9.2-1.4 18.4-1.2 27.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m561.1 501.2q1 2.2 2.1 4.4c2.1 4.4 4.2 9.2 3 14-0.7 2.6-2.4 4.9-3.9 7.3q-2-3.9-3.8-7.8c-0.7-6.1 0.2-12.3 2.6-17.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m810.1 638.7c-1.1 2.1-4.3 1.3-6-0.3-1.7-1.7-3.1-4-5.4-4.3-3.3-0.5-5.6 3.1-8.7 4-3.7 1.2-7.5-1.5-11.4-1.3-3.2 0.2-3.5 2.1-5.8 3.5-2.7 1.7-6 2-8.9 3.3-3 1.4-5.3 3.7-7.8 5.8-12.6 10.2-28 12.2-43.5 14.2-18.1 2.4-36.3 3-54.5 2.8q-12.5-0.1-25.1-0.2c-13.6-0.2-27.3-0.3-40.9-1.6 2.3-0.2 4.6-0.9 6.8-1.6 7.7-2.7 15.6-5.3 22.2-10 4.2-3 5.7-5.7 7.6-10.3 2.7-6.3 4.9-12.7 7-19.2q1.2-3.5 2.3-6.9c0.3-0.9 0.6-1.9 0.9-2.8 18.7 7.9 38.8 12.3 59.1 13.2 11.1 0.5 22.1-0.2 33.1-1.8 11.1-1.6 19.9-5.8 29.8-11.2 9.1-5 20.2-9.2 29.8-5.1 6.3 2.7 10.7 8.5 14 14.4 2.1 3.9 3.8 7.9 5.2 12 0.4 1.1 0.7 2.4 0.2 3.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m550.9 652.5c-0.2 3.1-1.1 6.1-2 9.1q-1.6 5.2-3.2 10.3c-0.2 0.5-0.3 0.9-0.6 1.3q-0.1 0-0.1 0c-0.9 0.8-2.4 0.3-3.4-0.4-7-4.7-9.4-13.8-10.8-22.2-1.4-9-2.2-18.2-2.4-27.3-0.2-9.2 0.2-18.4 1.2-27.6q7.7 9 15.5 18 0.3 0.4 0.6 0.7c0.3 8.8 1.4 17.5 3.4 26.1 0.9 3.9 2 7.9 1.8 12z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m587.9 664.1q0.2 0 0.4 0.1-0.2 0-0.5-0.1 0 0 0-0.1 0.1 0.1 0.1 0.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m638.9 613.8c-0.3 0.9-0.6 1.9-0.9 2.8q-1.1 3.4-2.3 6.9c-2.1 6.5-4.3 12.9-7 19.2-1.9 4.6-3.4 7.3-7.6 10.3-6.6 4.7-14.5 7.3-22.2 10-2.2 0.7-4.5 1.4-6.8 1.6q-1.9-0.2-3.8-0.4-0.2-0.1-0.4-0.1 0 0-0.1-0.1c-2.1-0.7-3.8-2.4-5.4-4-3.9-4-7.5-8.3-10.6-13q0.7-0.1 1.4-0.2c2.4-0.5 4.9-0.9 7.3-1.6 21.2-5.7 37.8-25.2 40.6-46.8q0.3-2.4 0.4-4.7c5.3 2.7 16.1 9.8 17.5 16 0.3 1.4 0.2 2.7-0.1 4.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m592.1 664.6q-1.9-0.2-3.8-0.4 1.9 0.5 3.8 0.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m664.9 1029.8c-0.3 3.6-1.1 6.1-2.6 8.3l-51.7 1.3-94.6-56.8c-0.7-0.4-1.5-0.5-2.2-0.2 0.3-4.7 2.9-9.5 4.9-13.3 2.4-4.5 6.1-14.4 12.6-13.5 3.3 0.5 5.8 2.2 7.8 4.5 4.1 4.6 6.6 11.3 12 14.2 4.9 2.7 10.5 3 16.2 2.8 6.9-0.1 14.1-0.9 20.3 1.7 8.9 3.7 16.6 9.9 23.3 16.8 3 3 5.8 6.3 9.5 8.4 12.6 7.2 38.9-5.1 44.1 14.1 1 3.8 0.8 7.8 0.4 11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m711.1 759.3c-22.5 44.9-46.2 89.9-75.6 130.8-13.5 18.8-28.6 36.4-41.4 55.7-3.7 5.5-7.2 11.1-10.6 16.7-2.4 3.9-4.1 10.7-9.4 11-1.6 0.1-3.1-0.2-4.6-0.7-1.6-0.6-3.2-1.5-4.7-2.3q-11.9-6.5-23.7-13-0.2-0.1-0.4-0.2c-1.4-0.8-2.8-1.7-3.7-3-1.2-2-1.1-4.4-0.8-6.7 3-25.6 15.4-49.1 27.9-71.6 22.2-40 52-75.5 68.6-118.6-1.7 4.5-19.9 6.1-23.7 6.9-24.5 5.7-49.2 11.5-74.2 14.8-26.4 3.4-52.9 5-79.5 6.2-7.4 0.3-16.8 2-23.7-0.8-6.8-2.6-12.3-8.6-15.7-15 3.9-8.6 9.9-16.2 15.7-23.7 7.5-9.4 15.2-19.1 25.9-24.6 9.3-4.8 19.9-5.9 30.1-8.4 20.1-4.9 39.3-15.9 55.9-28 1-0.7 2-1.5 2.4-2.6q0.1-0.1 0.1-0.2 0-0.2 0.1-0.3c42.3-1.7 84.8-3 127.1 0.3 11.4 0.8 23.2 2.2 32.9 8.4 8.7 5.6 14.9 15.1 16.5 25.4 2.4 15.1-4.7 29.9-11.5 43.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m569.5 972.8q-1.1 2.2-2.2 4.3c-5.7 0.2-11.3-0.1-16.2-2.8-5.4-2.9-7.9-9.6-12-14.2q0.8-1.4 1.6-2.8 0.2 0.1 0.4 0.2 11.8 6.5 23.7 13c1.5 0.8 3.1 1.7 4.7 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m662.4 1038.1v4c0 2.3-1.9 4.1-4.2 4.1h-51.4l-95.9-55.1c-1.3-0.8-1.7-2.5-0.9-3.7l2.3-3.9c0.4-0.5 0.9-0.9 1.5-1.1 0.7-0.3 1.5-0.2 2.2 0.2l94.6 56.8 51.7-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m648.7 611.3q-0.1 0.2-0.2 0.4-1.3 2.4-2.9 4.7-3.4-1.2-6.7-2.6c0.3-1.4 0.4-2.7 0.1-4.1-0.7-3.1-3.8-6.4-7.3-9.3q0.7-0.8 1.4-1.6c0.6-0.6 1.2-1.2 2-1.3 0.7-0.1 1.4 0.4 2.1 0.8 4 2.6 7.7 5.7 10.9 9.3 0.5 0.5 1 1.1 1.1 1.8 0.1 0.7-0.2 1.3-0.5 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m648.5 611.7q0.1-0.2 0.2-0.4c15.9 6 33.6 7.7 50.4 9.6 14 1.5 28 2.2 42.1 2-3.2 1-6.5 1.8-10.1 2.3-11 1.6-22 2.3-33.1 1.8-17.9-0.8-35.6-4.3-52.4-10.6q1.6-2.3 2.9-4.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m834.6 612.1c-2.7 1.7-6.2 1.3-9.2 0.4-3-0.9-5.9-2.3-9.1-2.5-0.8 0-1.7 0.1-2.2 0.6-0.8 0.8-0.5 2.2 0.2 3 0.8 0.9 1.8 1.3 2.8 1.9 3.2 2 5.2 6 4.8 9.8-2.8 1-5.7-1.2-8.1-3-2.5-1.8-6.2-3.2-8.3-1-0.5 0.5-0.8 1.1-1 1.8-3.2-5.9-7.6-11.5-13.8-14.2-3.4-1.4-7-1.8-10.7-1.5 8.9-6.3 18.8-11.9 29.7-9.6 8.1 1.6 15.2 6.2 22.1 10.8 1.3 0.9 2.7 2 2.8 3.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m406.6 688.6c0 29-1.3 57.9-2.8 86.9q0 0.3 0 0.6c-1.1 13.8-13.6 12.1-16.9-0.1-2.8-10.3-1.5-21-1.6-31.5q-0.1-17.6-1-35.2-1.3-25.4-4.1-50.7-1-9.7-2.3-19.4c-0.3-2-0.6-4-0.8-6-6.1-44-15.4-87.6-27.5-130.4-2.6-9-5.3-18.2-5.4-27.6-0.1-4.8 1.7-10.8 6.4-11.2 3.2-0.2 5.8 2.4 7.8 4.8 25 30.7 35 76 41 114.3 5.5 34.8 7.3 70.2 7.2 105.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m489.2 897.7h-14.7v-77.8h14.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m498.2 984.5h-32.6v-86.8h32.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m504.3 992.2h-44.8v-7.7h44.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m490.1 1004.2h-16.5l-4.6-12h25.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m469 992.2l3.9 10-102.9 51.9v-7.9l89.5-54z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s20",
    cx: 365.8,
    cy: 1049.5,
    r: 12.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m504.3 992.2l89.5 54v7.9l-102.9-51.9 3.9-10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "<Path>",
    className: "s20",
    cx: 597.9,
    cy: 1049.5,
    r: 12.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m515.7 785.8h-23.6l-3.1-110.9h28.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m581.6 680.1c-44.3 2.4-89.2 1.4-133.7 2.3-1.5 0-3 0-4.2-0.9-1-0.6-1.5-1.7-2-2.8-4.4-9.6-2.2-19.6 8.6-24.1 5.9-2.5 12.5-2.6 18.9-2.7 39.3-0.5 77.4-2.5 115.9 7 2.2 0.5 4.3 1.1 6.1 2.3 4.1 2.8 5.4 8.8 2.8 12.9-2.5 4.1-7.6 5.7-12.4 6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m601.5 792.8c0 3.7-0.5 7.3-1.3 10.8h-0.2-190.2c0.1-5.2-0.1-10.5 3.5-13.9 2.1-2 5.1-2.8 8-3.3 10.6-2.2 21.5-2.8 32.3-3.4q22.6-1.3 45.2-2.6c20.7-1.2 41.5-2.5 62.3-3.2 14.7-0.6 40.4-6.5 40.4 15.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m600 803.6v1 15.3h-226.4c-7.4 0-13.7-5.6-14.5-13l-14.3-128.9c-0.4-3.6 0.7-7.3 3.1-10.2l29.2-34.6c0.2 2 0.5 4 0.8 6q1.3 9.7 2.3 19.4l-19.7 17.9 12.2 127.1h37.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m484.4 1062.2h-18l192.1-386.2h53.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m505.3 984.1l22.1 5.2-43 72.9h-18z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m703 691.6h-52.3l7.8-15.6h53.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m913.8 676h53.8l192 386.2h-17.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m1159.6 1062.2h-17.9l-43-72.9 22.1-5.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m913.8 676h53.8l7.7 15.6h-52.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m1006.1 687.4h-386.1v-22.8h386.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m884.3 459.2l-5.9-5.1h-9.8v-31.7h13.5v18.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m913.7 549l-15.2 104.2h-9l15.2-104.2-26.3-94.9 3.7-20.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m862.6 560.4c-4.6 0-8.2-3.6-8.3-8.2l-2.9-216.9c0-5.2 4.5-9.1 9.6-8.3l2.9 0.4c4 0.6 7 4.1 7 8.2v216.5c0 4.6-3.7 8.3-8.3 8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m827 663.2v1.4h-79.1v-2.8c0-6.3 5.2-11.4 11.6-11.3l56.5 1.4c6.1 0.2 11 5.2 11 11.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m953.5 664.6h-111.4l-0.4-3.6c-0.6-5.5 3.8-10.3 9.3-10.2l93.2 2.3c4.5 0.1 8.2 3.5 8.9 8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreat);
export default __webpack_public_path__ + "static/media/great.6bd5343cb91d3d9f8c57e4a5855f467e.svg";
export { ForwardRef as ReactComponent };